import { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Sparkles, ArrowRight } from 'lucide-react';
import { specials, BOOKING_URL } from '../data/services';

const additionalSpecials = [
  {
    id: 4,
    title: "Goddess Glow Package",
    description: "Combine IV therapy with skin boosters for ultimate radiance from within",
    price: "$599 (reg. $750)",
    badge: "Popular"
  },
  {
    id: 5,
    title: "Weight Loss Starter",
    description: "Begin your transformation with our comprehensive GLP-1 program",
    price: "$349 first month",
    badge: "New"
  }
];

export const SpecialsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const allSpecials = [...specials, ...additionalSpecials];

  return (
    <main data-testid="specials-page" className="pt-24 bg-chalk min-h-screen">
      {/* Hero */}
      <section className="py-16 lg:py-24 text-center px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <p className="font-cinzel text-amaranth text-xs tracking-[0.3em] mb-4">
            EXCLUSIVE OFFERS
          </p>
          <h1 className="font-serif text-dark text-4xl lg:text-6xl mb-6">
            Current Specials
          </h1>
          <p className="text-dark-secondary max-w-2xl mx-auto">
            Take advantage of our limited-time offers and experience the transformative 
            treatments at Aphrodite Med Spa at exclusive pricing.
          </p>
        </motion.div>
      </section>

      {/* Specials Grid */}
      <section className="px-6 pb-24">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {allSpecials.map((special, index) => (
              <motion.div
                key={special.id}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                data-testid={`special-${special.id}`}
                className="group relative bg-light p-8 lg:p-10 hover:shadow-soft transition-shadow duration-300"
              >
                {/* Badge */}
                <span className="absolute top-4 right-4 bg-amaranth text-white text-xs px-3 py-1 rounded-full">
                  {special.badge}
                </span>

                {/* Icon */}
                <div className="w-12 h-12 bg-thulian/10 flex items-center justify-center mb-6">
                  <Sparkles className="text-amaranth" size={24} />
                </div>

                {/* Content */}
                <h3 className="font-serif text-dark text-2xl mb-3">
                  {special.title}
                </h3>
                <p className="text-dark-secondary text-sm mb-6 leading-relaxed">
                  {special.description}
                </p>

                {/* Price */}
                <p className="font-serif text-amaranth text-xl mb-6">
                  {special.price}
                </p>

                {/* CTA */}
                <a
                  href={BOOKING_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`book-special-${special.id}`}
                  className="btn-luxury inline-flex items-center gap-2 bg-amaranth text-white px-6 py-3 rounded-full text-sm font-medium"
                >
                  Book Now
                  <ArrowRight size={16} />
                </a>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Terms */}
      <section className="px-6 pb-24">
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-dark-secondary text-sm">
            * Specials cannot be combined with other offers. Subject to availability. 
            New client offers valid for first-time guests only. Please mention special 
            at time of booking. Contact us for full terms and conditions.
          </p>
        </div>
      </section>
    </main>
  );
};

export default SpecialsPage;
